import styled from "styled-components";
import { themes } from "../../Utils/themes";
import { device } from "../../Utils/device";

export const Section = styled.div`
  padding-top: 80px;
  margin: 0 20px;
  @media ${device.desktop} {
    padding-top: 60px;
    max-width: 1080px;
    margin: 0 auto;
  }
`;

export const StyledSectionTitle = styled.h1`
  font-size: ${themes.textSize.m3};
  @media ${device.tablet} {
    font-size: ${themes.textSize.l1};
  }
  @media ${device.desktop} {
    font-size: ${themes.textSize.l2};
  }
`;

export const SectionTitle = styled.h2`
  font-family: "NotoSansCJKjp-Regular" !important;
  font-size: ${themes.textSize.m2};
  padding: 6px 12px;
  margin: 30px 0 10px;
  box-shadow: 6px -6px ${themes.colors.primary};
  outline: 3px solid ${themes.colors.white};
  border: 3px solid ${themes.colors.primary};
  position: relative;
  @media ${device.tablet} {
    padding: 12px 24px;
    margin: 60px 0 20px;
    font-size: ${themes.textSize.m3};
  }
  @media ${device.desktop} {
    padding: 12px 24px;
    margin: 60px 0 20px;
    font-size: ${themes.textSize.l1};
    margin: 100px 0 20px;
  }
`;

export const CushionTitle = styled.h3`
  font-family: "NotoSansCJKjp-Regular" !important;
  padding: 4px 10px;
  border-top: 2px solid ${themes.colors.primary};
  border-bottom: 2px solid ${themes.colors.primary};
  width: fit-content;
  min-width: 250px;
  margin: 30px auto;
  text-align: center;
`;

export const EnvelopeField = styled.div`
  display: flex;
  align-items: end;
  gap: 10px;
  justify-content: center;
  margin: 0px auto 30px;
  @media ${device.desktop} {
    margin: 10px auto 30px;
  }
`;

export const SPBR = styled.br`
  @media ${device.tablet} {
    display: none;
  }
`;

export const NeedField = styled.div`
  background-color: ${themes.colors.background};
  border: 2px solid ${themes.colors.border};
  border-radius: 8px;
  padding: 10px;
  font-weight: bold;
  color: #878787;
  margin: 0 auto;
  @media ${device.desktop} {
    margin-top: 10px;
  }
`;

export const PCFlex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  margin: 10px auto 30px;
  @media ${device.desktop} {
    align-items: end;
    flex-flow: nowrap;
    margin: 10px auto 20px;
  }
`;

export const Field = styled.div`
  width: fit-content;
  height: fit-content;
  font-weight: bold;
  white-space: nowrap;
  @media ${device.desktop} {
    margin-top: 10px;
  }
`;

export const Description = styled.p`
  display: block;
  font-size: ${themes.textSize.s3};
  text-align: left;
  margin-top: 18px;
  margin-bottom: 18px;
  @media ${device.desktop} {
    font-size: ${themes.textSize.m1};
  }
`;

export const SmallDescription = styled.p`
  display: block;
  font-size: ${themes.textSize.s2};
  margin-top: 7px;
  margin-bottom: 7px;
  @media ${device.desktop} {
    font-size: ${themes.textSize.s3};
  }
`;

export const YamatoTimeImg = styled.img`
  width: 100%;
  max-width: 500px;
`;

export const YamatoCompactBoxImg = styled.img`
  width: 100%;
  max-width: 160px;
  @media ${device.desktop} {
    max-width: 250px;
  }
`;
export const YamatoEnvelopeImg = styled.img`
  width: 100%;
  max-width: 100px;
  @media ${device.desktop} {
    max-width: 150px;
  }
`;
